import styled from 'styled-components';

export const TooltipAreaContainer = styled.div`
    position: abosolute;
    left: 0;
    top: 0;

    [data-id='chart-tooltip'] {
      display: block;
      position: absolute;
    
    }

`

export const HoverAreaContainer = styled.div`
 
    position: relative;
    width: 100%;
    height: 100%;
  
    

`